var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeople3Humen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_272_1680)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#E3E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7622 26.1484C42.2939 26.1484 40.927 26.5891 39.7852 27.3441C41.6424 28.5028 43.1495 30.1726 44.1065 32.156H49.2485C50.135 32.156 50.7274 31.242 50.3651 30.433C49.2353 27.9103 46.7006 26.1484 43.7622 26.1484Z",
    fill: "#17468C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7636 23.703C45.4199 23.703 46.7674 22.3555 46.7674 20.6992C46.7674 19.0428 45.4199 17.6953 43.7636 17.6953C42.1073 17.6953 40.7598 19.0428 40.7598 20.6992C40.7598 22.3555 42.1073 23.703 43.7636 23.703Z",
    fill: "#17468C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.679 28.0425C31.4525 28.0425 29.4099 28.8442 27.8242 30.1741C30.4785 31.425 32.7019 33.4445 34.2054 35.9443H41.1934C42.0199 35.9443 42.615 35.1391 42.3596 34.3531C41.1708 30.6945 37.7288 28.0425 33.679 28.0425Z",
    fill: "#17468C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6794 25.5971C35.858 25.5971 37.6303 23.8248 37.6303 21.6462C37.6303 19.4676 35.858 17.6953 33.6794 17.6953C31.5008 17.6953 29.7285 19.4676 29.7285 21.6462C29.7285 23.8248 31.5008 25.5971 33.6794 25.5971Z",
    fill: "#17468C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5598 31.2202C15.7054 31.2202 10.7931 35.3302 9.55731 40.8166C9.38585 41.5776 9.97222 42.2997 10.7524 42.2997H32.3671C33.1473 42.2997 33.7337 41.5776 33.5622 40.8166C32.3263 35.3302 27.414 31.2202 21.5598 31.2202Z",
    fill: "#17468C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.099 23.2351C27.099 20.1805 24.6139 17.6953 21.5593 17.6953C18.5047 17.6953 16.0195 20.1805 16.0195 23.2351C16.0195 26.2898 18.5046 28.7748 21.5593 28.7748C24.6138 28.7748 27.099 26.2898 27.099 23.2351Z",
    fill: "#17468C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_272_1680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople3Humen);
export default __webpack_public_path__ + "static/media/people-3-humen.886fd81842b024b9bf6c031517cb9421.svg";
export { ForwardRef as ReactComponent };